import imgAbout from '../../images/about.png'
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai'
import { useState } from 'react'

const About = () => {
  const [showParagraph1, setShowParagraph1] = useState(false);
  const [showParagraph2, setShowParagraph2] = useState(false);
  const [showParagraph3, setShowParagraph3] = useState(false);
  const [isIconDown1, setIsIconDown1] = useState(true);
  const [isIconDown2, setIsIconDown2] = useState(true);
  const [isIconDown3, setIsIconDown3] = useState(true);
  
  
  const handleToggleParagraph1 = () => {
    setShowParagraph1(!showParagraph1);
  }

  const handleToggleParagraph2 = () => {
    setShowParagraph2(!showParagraph2);
  }

  const handleToggleParagraph3 = () => {
    setShowParagraph3(!showParagraph3);
  }

  const handleToggleIcon1 = () => {
    setIsIconDown1(!isIconDown1);
  }
  const handleToggleIcon2 = () => {
    setIsIconDown2(!isIconDown2);
  }
  const handleToggleIcon3 = () => {
    setIsIconDown3(!isIconDown3);
  }

  return (
      <div className="about" id="about">
        <div className="image-article">
          <img src={imgAbout} alt="" loading="lazy"/>
        </div>
        <div className='inside-article'>
          <h1>About us</h1>
          <h4 >Our Journey to Creativity: The Story of Aliquam Studios</h4>
          <p className='show'>Our story began in 2011, when a small group of passionate individuals founded Aliquam Creative - one of the earliest creative servers in existence, which is still actively played today. As time went on, the owner of this server saw an opportunity to expand on their vision, which led to the establishment of Aliquam Studios. Our goal is to constantly push the boundaries of creativity, not just within Minecraft but beyond it as well.</p>
          <h4 >Preserving Cultural Heritage Through Minecraft {isIconDown1 ? <AiFillCaretDown className='down' onClick={() => {handleToggleParagraph1(); handleToggleIcon1();}}/> : <AiFillCaretUp className='up' onClick={() => {handleToggleParagraph1(); handleToggleIcon1();}}/>}</h4>
          {showParagraph1 &&
          <p className='show'>At Aliquam Studios, we take pride in creating projects that are rooted in factual cultural heritage. We firmly believe that Minecraft is an ideal platform to educate players about their culture and history. Our cultural projects have garnered local media attention on numerous occasions, which serves as a testament to the quality of our work.</p>}
          <h4 >Customized Projects for Your Needs {isIconDown2 ? <AiFillCaretDown className='down' onClick={() => {handleToggleParagraph2(); handleToggleIcon2();}}/> : <AiFillCaretUp className='up' onClick={() => {handleToggleParagraph2(); handleToggleIcon2();}}/>}</h4>
          {showParagraph2 && <p className='show'>No matter what your needs are, we are happy to accommodate them. Whether you require a simple Minecraft server spawn or a more complex virtual exhibition for an educational institution, we are up for the challenge. At Aliquam Studios, we are committed to delivering the best possible results for our clients. Our team of experienced and talented individuals is passionate about crafting virtual worlds in Minecraft, and we strive to combine stunning graphics and interactivity to create projects that capture attention with their originality and ingenuity.</p>}
          <h4 >Advanced Projects and Creations at Aliquam Studios{isIconDown3 ? <AiFillCaretDown className='down' onClick={() => {handleToggleParagraph3(); handleToggleIcon3();}}/> : <AiFillCaretUp className='up' onClick={() => {handleToggleParagraph3(); handleToggleIcon3();}}/>}</h4>
          {showParagraph3 && <div className='show'>
            <p>Aliquam Studios is a team of experienced and talented creators who are true enthusiasts of Minecraft. Our team is well-known for crafting high-quality and popular Skin Packs that add new possibilities to the game, as well as creating advanced projects that captivate with their originality.</p>
            <p>Our creators possess a wealth of experience in designing virtual worlds in Minecraft and continuously hone their skills to stay at the forefront of innovation in the field. Thanks to their knowledge and creativity, we create projects that not only look stunning, but also offer interactive and unforgettable experiences for players.</p>
            <p>Our passion for Minecraft and our dedication to crafting drives us to work with professionalism and commitment. The projects we have built so far have garnered recognition both among the gaming community and our clients. At Aliquam Studios, we always set high standards for ourselves and strive to deliver projects that exceed our clients' expectations.</p>
          </div>}
        </div>
      </div>
  )
}

export default About




